import { createIcon } from '@chakra-ui/icons';

export const FavIcon = createIcon({
  displayName: 'FavIcon',
  viewBox: '0 0 76 76',
  d: 'm64.88 11.13a38 38 0 0 0 -53.76 53.74 38 38 0 1 0 53.76-53.74zm-50.47 14.19h7v19.79h5.8v6.09h-12.8zm48 35.28a32.7 32.7 0 0 1 -39.82 5 29 29 0 1 0 2.24-57.43 32.7 32.7 0 0 1 37.61 52.43zm-23.79-15a5.3 5.3 0 0 0 3.48-1.49l1.69 5.72a10.94 10.94 0 0 1 -6 1.9c-5.76 0-9.77-3.27-9.77-13.54 0-9.61 3.89-13.5 9.73-13.5a11.2 11.2 0 0 1 6 1.78l-1.75 5.97a5.27 5.27 0 0 0 -3.35-1.57c-2.36 0-3.52 2-3.52 7.24.04 5.43 1.2 7.54 3.52 7.54z',
});
